var _defs, _style, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLitigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 20,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 29,
    height: 29,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAAAXNSR0IB2cksfwAAAPNQTFRFAAAAcF6nc1ymdF2lbVqhdl6ndl6odFymclekaFWhdl2odl6oclqoQECAdl2odl6ndF2bdV2ldUmodV2mdl6kVVWVdl6odF6oAAAAclqidV2mbFufdF2XdV2nc1yodVqjclymdV6kclundlundVqoaVqldlmlZlyZbF6edV2odV6lcV6lZV6odV6mc1yec1ymdV2nb12halWndF2ldF2ndVyidF2cdVqkc1yodVyoc1qidluidV2ndlilcF6mVVWAZjOZSUmSYECAVVWcdl6mdVuodl2mdF6oa06lc12ndF10dV2gdF6ndl6odlyndl2oc1yoK/cBqwAAAFF0Uk5TAGLIYza2/7c4G4/19gRm30LAI539DHXnAUrLLRZrb15nbWVoaRGNMleMkEQmsVm9qIdUxrCOWIOyr0dzs105BgUHCBKpzc7PPqILdovqxeHeB5iWWAAAAQ5JREFUeJzlkvtOwjAYR39jWKXKuMNA3Rx44eIEBGQTcEzd5g3w/Z/Gr9k0EBgv4PnjpOlJ2iZfgXWkhIw4kgeMscOjnS3Fj5nghKe2WlrJsF8ySnozZnNsnVx2reULRbZJsZCPWqlcYdtUyiVqarW2owlqVRXJmCY4xdm5Jum6fmHI5LpRJ8tGgyxpl1fiYoVf8xs0eavdQafd4k3c0o4SvkpN0CEaTDIHJ5u4IyfUsHZp3UCP3Eef3MM9uftP64DWBobkEUbkIR7Ig7BibNnWIyZTezrDjDzBk2lb42j8jjN33GdhJ7Ir7Ir28ur5nucHpD8H5MB7o/oeO3z/A597/sYXFnvqAsvVdxyr5Q/cVT4BX9njwQAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\ttspan { white-space:pre }\r\n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 2,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitigation);
export default __webpack_public_path__ + "static/media/Litigation.47dd3bd84f2524bea2c6eabdc3d93dd7.svg";
export { ForwardRef as ReactComponent };